import React from "react";
import "./MapLocations.css";
import { Link, useHistory, useParams } from "react-router-dom";
import API from "../../utils/API";
import { prepareStageEntry, getDefaultSpawn } from "../../config/worldTransitions";


function Forest() {
    const {id} = useParams()
    const history = useHistory()
    return(
        <div className="map-location text-center special forestDiv">
            <img src={require("../../images/mapForest.png")} alt="Forest" className="forest" />
            <Link className="stage-link map-location__control" to={"/forest/" + id} onClick={async (event) => {
                event.preventDefault()
                prepareStageEntry(id, "forest", getDefaultSpawn("forest"))
                try { await API.UpdateSpritePlace("forest", id) } finally { history.push("/forest/" + id) }
            }}>Forest</Link>
        </div>
    )
}

export default Forest;